"use client";

import { create } from "zustand";

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  level: number;
  xp: number;
  streak: number;
}

interface AppState {
  user: SessionUser | null;
  demoMode: boolean;
  aiOnline: boolean;
  activeGoalId: string | null;
  sidebarOpen: boolean;
  setSession: (user: SessionUser | null, ai?: { configured: boolean }) => void;
  setDemoMode: (demo: boolean) => void;
  setActiveGoal: (goalId: string | null) => void;
  setSidebarOpen: (open: boolean) => void;
  updateUser: (patch: Partial<SessionUser>) => void;
}

export const useAppStore = create<AppState>((set) => ({
  user: null,
  demoMode: false,
  aiOnline: true,
  activeGoalId: null,
  sidebarOpen: false,
  setSession: (user, ai) =>
    set({ user, ...(ai ? { demoMode: !ai.configured, aiOnline: true } : {}) }),
  setDemoMode: (demo) => set({ demoMode: demo }),
  setActiveGoal: (goalId) => set({ activeGoalId: goalId }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  updateUser: (patch) =>
    set((state) => ({ user: state.user ? { ...state.user, ...patch } : null })),
}));
